import React, { Component } from 'react'
import { observer } from 'mobx-react'
import {
    Button,
    Col,
    ControlLabel,
    Form,
    FormGroup,
    Panel,
    PanelGroup
} from 'react-bootstrap'
import { browserHistory } from 'react-router'

import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'

import Collapsible from '../collapsible'
import DatePicker from 'react-bootstrap-date-picker'
import Loadable from 'react-loading-overlay'

@observer(['companies', 'globals'])
export default class LeadCountReport extends Component {

    constructor(props) {
        super(props)

        this.state = {
            startDate: '',
            endDate: '',
            loadableState: false,
            leadCountBreakdownLoadable: false,
            showCompanyDetailsCollapsible: false
        }
    }

    componentDidMount() {
        if (this.props.companies.sourceLeadCountByDateRange.length > 0 && (this.state.startDate == '' || this.state.endDate == '')) {
            this.props.companies.resetSourceLeadCountByDateRange()
        }
    }

// FORM VALIDATION FUNCTIONS
    validateReportForm() {
        if (this.getStartDateValidationState() == 'error') {
            return false
        }

        if (this.getEndDateValidationState() == 'error') {
            return false
        }

        return true
    }

    getStartDateValidationState() {
        if (this.state && this.state.startDate != '') {
            return 'success'
        } else {
            return 'error'
        }
    }

    getEndDateValidationState() {
        if (this.state && this.state.endDate != 0) {
            return 'success'
        } else {
            return 'error'
        }
    }

//STATE CHANGE FUNCTIONS
    onStartDateChanged(value, formattedValue) {
        if (formattedValue == null) {
            formattedValue = ''
        }

        this.setState({
            startDate: formattedValue
        })
    }

    onEndDateChanged(value, formattedValue) {
        if (formattedValue == null) {
        formattedValue = ''
        }

        this.setState({
            endDate: formattedValue
        })
    }

//PROCESSING FUNCTIONS
    runSourceLeadCountByDateRangeReport() {
        this.setState({
            loadableState: true
        })

        if (this.validateReportForm()) {
            this.props.companies.getSourceLeadCountByDateRange(this.state.startDate, this.state.endDate, () => {
                this.setState({
                    loadableState: false
                })          
            })
        }
        else {
            alert('Please check the form.  Required data is missing.')
            this.setState({
                loadableState: false
            })
        }
    }

    runCompanyDetailsBySourceByDateRangeReport(sourceId) {
        this.setState({
            showCompanyDetailsCollapsible: true,
            leadCountBreakdownLoadable: true
    
        })
    
        this.props.companies.getCompanyDetailsBySourceByDateRange(sourceId, this.state.startDate, this.state.endDate, () => {
          this.setState({
            leadCountBreakdownLoadable: false
          })
        })
    }

    formatActionsReport(cell, row) {

        return (
          <div>
            <Button bsSize="small" bsStyle="warning" id={ cell } onClick={ () => { this.runCompanyDetailsBySourceByDateRangeReport(cell) } }><i className="fa fa-pencil-square-o" aria-hidden="true"></i></Button>
          </div>
        )
    }

    formatActionsBreakdown(cell, row) {

        return (
          <div>
            <Button bsSize="small" bsStyle="warning" id={ cell } onClick={ () => { browserHistory.push('/company/details/' + row.id) } }><i className="fa fa-pencil-square-o" aria-hidden="true"></i></Button>
          </div>
        )
      }

    render() {

        let leadCountReportTable = <div>Select a date range above.</div>

        if (this.props.companies.sourceLeadCountByDateRange.length > 0) {
            leadCountReportTable = (
                <div>
                <Loadable active={ this.state.loadableState } spinner text='Processing your request...'>
                    <BootstrapTable
                        data={ this.props.companies.sourceLeadCountByDateRange }
                        striped={ true }
                        hover={ true }
                        pagination={ true }
                        bordered={ true }
                        >
                        <TableHeaderColumn width="100" isKey={true} dataField="name" dataSort={ true } >Source</TableHeaderColumn>
                        <TableHeaderColumn width="100" dataField="count" dataSort={ true }>Count</TableHeaderColumn>
                        <TableHeaderColumn width="50" dataField="sourceId" hiddenOnInsert={ true } autoValue={ true } dataFormat={ this.formatActionsReport.bind(this) }>Actions</TableHeaderColumn>
                    </BootstrapTable>
                </Loadable>
                </div>
            )
        }

        let companyDetailsTable = ''

        if (this.props.companies.companyDetailsBySourceByDateRange.length > 0) {
            companyDetailsTable = (
                <div>
                <Loadable active={ this.state.leadCountBreakdownLoadable } spinner text='Processing your request...'>
                    <BootstrapTable
                        data={ this.props.companies.companyDetailsBySourceByDateRange }
                        striped={ true }
                        hover={ true }
                        pagination={ true }
                        search={ true }
                        exportCSV={ true }
                        bordered={ true }
                        >
                        <TableHeaderColumn width="100" isKey={true} dataField="name" dataSort={ true } filter={ { type: 'TextFilter', delay: 50 } }>Company</TableHeaderColumn>
                        <TableHeaderColumn width="50" dataField="fullName" dataSort={ true } filter={ { type: 'TextFilter', delay: 50 } }>Contact</TableHeaderColumn>
                        <TableHeaderColumn width="75" dataField="email" dataSort={ true } filter={ { type: 'TextFilter', delay: 50 } }>Email</TableHeaderColumn>
                        <TableHeaderColumn width="50" dataField="phone" dataSort={ true } filter={ { type: 'TextFilter', delay: 50 } }>Phone</TableHeaderColumn>
                        <TableHeaderColumn width="100" dataField="address" dataSort={ true } filter={ { type: 'TextFilter', delay: 50 } }>Address</TableHeaderColumn>
                        <TableHeaderColumn width="50" dataField="userFullName" dataSort={ true } filter={ { type: 'TextFilter', delay: 50 } }>Assigned</TableHeaderColumn>
                        <TableHeaderColumn width="50" dataField="vendorName" dataSort={ true } filter={ { type: 'TextFilter', delay: 50 } }>Vendor</TableHeaderColumn>
                        <TableHeaderColumn width="50" dataField="sourceName" dataSort={ true } filter={ { type: 'TextFilter', delay: 50 } }>Source</TableHeaderColumn>
                        <TableHeaderColumn width="50" dataField="id" hiddenOnInsert={ true } autoValue={ true } dataFormat={ this.formatActionsBreakdown.bind(this) }>Actions</TableHeaderColumn>
                    </BootstrapTable>
                </Loadable>
                </div>
            )
        }

        let companyDetailsCollapsible = ''

        if (this.state.showCompanyDetailsCollapsible) {
            companyDetailsCollapsible = (
            <div>
              <Collapsible title="Lead Count Breakdown" content={ companyDetailsTable } />
              <div className="clearfix"></div>
            </div>
          )
        }

        return (
            <div>
                <div>
                    <PanelGroup>
                        <Panel header="Report Options">
                            <Form>
                                <FormGroup>
                                    <Col sm={ 2 } componentClass={ ControlLabel }>Start Date:</Col>
                                    <Col sm={ 4 }>
                                    <FormGroup validationState={ this.getStartDateValidationState() }>
                                        <DatePicker id="startDate" dateFormat="YYYY-MM-DD" value={ this.state.startDate } onChange={ this.onStartDateChanged.bind(this) }/>
                                    </FormGroup>
                                    </Col>
                                </FormGroup>
                                <FormGroup>
                                    <Col sm={ 2 } componentClass={ ControlLabel }>End Date:</Col>
                                    <Col sm={ 4 }>
                                    <FormGroup validationState={ this.getEndDateValidationState() }>
                                        <DatePicker id="endDate" dateFormat="YYYY-MM-DD" value={ this.state.endDate } onChange={ this.onEndDateChanged.bind(this) }/>
                                    </FormGroup>
                                    </Col>
                                </FormGroup>
                            </Form>
                            <div style={{ float: 'right' }}>
                                <Button bsStyle="success" onClick={ this.runSourceLeadCountByDateRangeReport.bind(this) }><i aria-hidden="true"></i>Run Report</Button>
                            </div>
                        </Panel>
                    </PanelGroup>
                </div>
                <div className="clearfix"></div>
                <Collapsible title="Lead Count Report" content={ leadCountReportTable } />
                <div className="clearfix"></div>
                { companyDetailsCollapsible }
            </div>
        )   
    }
}



// WEBPACK FOOTER //
// ./src/components/reports/leadcountreport.js